// import { Button, Paper } from "@mui/material";
// import CustomText from "components/typography/CustomText";
import { Grid } from "@mui/material";
import { ERR_NETWORK } from "constants/messages";
import { getSubscriptionDetails } from "models/subscriptionsModel";
import { useSnackbar } from "notistack";
import InvoiceTable from "pages/customers/detail/InvoiceTable";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import CustomerInfo from "./CustomerInfo";
import SubscriptionSummaryInfo from "./SubscriptionSummaryInfo";
import { formatArray } from "lib/arrayObject";
// import PaymentMethods from "./PaymentMethods";

export default function SubscriptionDetailsComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState({});
  const { orderId = "" } = useParams();

  const loadDetailsData = (orderId) => {
    getSubscriptionDetails({
      orderId: orderId,
      onFinish: (res, err) => {
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        setData(res);
      },
    });
  };

  const handleUpdate = (res, err) => {
    if (res === false) {
      if (!res && err?.message) {
        enqueueSnackbar(err?.message, { variant: "warning" });
      } else {
        enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
      }
      return;
    }
    enqueueSnackbar("Successfully Updated in.", { variant: "success" });
    loadDetailsData(orderId);
    // setData((s = {}) => ({ ...s, ...{ ...res, pies: s?.pies ?? [] } }));
  };

  const handleEditUser = (res) => {
    setData((s = {}) => ({
      ...s,
      name: res.name,
      phone: res.phone,
      user_status: res.status,
    }));
  };

  useEffect(() => {
    loadDetailsData(orderId);
    //eslint-disable-next-line
  }, [orderId]);

  return (
    <div>
      <SubscriptionSummaryInfo data={data} onUpdate={handleUpdate} />
      <div className="my-4">
        <Grid container spacing={2}>
          <Grid className="flex" item lg={4} md={4} sm={12} xs={12}>
            <CustomerInfo data={data} onEditUser={handleEditUser} />
          </Grid>
          <Grid item lg={8} md={8} sm={12} xs={12}>
            <InvoiceTable
              data={
                formatArray(data?.slots).map((item, index) => {
                  return { ...item, box_type: true };
                }) ?? []
              }
            />
          </Grid>
        </Grid>
      </div>
      {/* <PaymentMethods data={data} />
      <div className="my-4">
        <Paper>
          <div className="p-4 flex justify-between items-center border-b border-white-gray">
            <CustomText variant="h6" bold={600}>
              Credit Balance
            </CustomText>
            <Button variant="contained">Adjust Balance</Button>
          </div>
          <div className="p-4">
            <CustomText variant="body" bold={500}>
              $0.00
            </CustomText>
          </div>
        </Paper>
      </div> */}
      {/* <HistoryTimeline /> */}
    </div>
  );
}
